import React from 'react';
import HeaderSmall from '../Components/Header/HeaderUnauthorized';
import Content from '../Components/Content';
import Paper from 'material-ui/Paper';
import { Chip } from 'material-ui';
import { fireInAppBrowserPlugin } from '../actions/environmentActions';

class PrivacyPolicyPage extends React.Component {
    render() {
        let companyId = window.COMPANY_ID
        return (
            <div>
                <HeaderSmall  useBackFunction={true}>
                    <span className="white" >Privacy Policy</span>
                </HeaderSmall>
                <Content contentKey="privacypolicy" />
                {window.COMPANY_ID === 6 && (
                    //code will need changed in the event we have more companies needing Google API Consent Screen Verification
                    <div>
                        <br /><br />
                        <div style={{position:'fixed', bottom:15, right:20}}>
                            <Chip 
                                style={{cursor:'pointer'}}
                                labelStyle={{color:'#FFF'}} 
                                backgroundColor={'#697586'}
                                onClick={()=>{fireInAppBrowserPlugin('https://healthchoice.medefy.com/privacy-policy')}}
                            >View Online</Chip>
                        </div>
                    </div>
                )}
            </div>
        );
    }
};

export default PrivacyPolicyPage;


// WEBPACK FOOTER //
// ./src/Pages/PrivacyPolicy.js